<script setup lang="ts">
  import { ComboboxEmpty } from 'reka-ui'
  import type { HTMLAttributes } from 'vue'
  import { cn } from '../../../lib/utils'

  const props = defineProps<{ class?: HTMLAttributes['class'] }>()
</script>

<template>
  <ComboboxEmpty
    data-slot="combobox-empty"
    :class="cn('text-muted-foreground py-6 text-center text-sm', props.class)"
  >
    <slot />
  </ComboboxEmpty>
</template>
